<template>
  <div>
    <PartnerHeader
      :img_header="header_image"
      header="รายการจัดการ POS"
      link_back="storeinformation"
    />
    <!-- <MenuPartner/> -->
    <Store_invoice_information />
  </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/process.png";
// import MenuPartner from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/MenuPartner";
import Store_invoice_information from "@/components/admin/manage_pos/partner_store_setting/Store_invoice_information";
export default {
  name: "StoreInvoiceInformation",
  components: {
    Store_invoice_information,
    //   MenuPartner,
    PartnerHeader,
  },
  data() {
    return {
      header_image: HeaderImage,
    };
  },
};
</script>

<style scoped></style>
